import { useWebBillingHost } from './context';
import type { BillingTransport } from './types';

/** The transport billing hooks pass to their fetchers. */
export function useBillingApi(): BillingTransport {
  return useWebBillingHost().api;
}
